<template>
  <div>
    <!-- 充值记录弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="充值管理"
      :visible.sync="recordDialogVisible"
      :before-close="recordHandleClose"
      width="38%"
      center
    >
      <el-divider></el-divider>
      <!-- 计费 -->
      <div class="conentBox" v-if="radioType==1">
        <div class="connetOne">
          <div>景区订单短信——计费</div>
          <div>
            <div>
              <span>计费类型：</span>
              <el-radio-group v-model="recordData.radio" @change="radioFn">
                <el-radio :label="1">计费</el-radio>
                <el-radio :label="2">计时</el-radio>
              </el-radio-group>
            </div>
            <div class="flex_moeny">
              <div>
                <span class="fswh">当前余额：</span>
                <span class="fsw" v-if="recordData.balance">{{recordData.balance}}</span>
                <span class="fswh">元</span>
              </div>
              <div>
                <span class="fswh">充值金额：</span>
                <el-input placeholder="请输入内容" v-model="recordData.amount" clearable>
                  <template>
                    <slot slot="suffix" class="input-slot">元</slot>
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="connetTwo">
          <div class="fsws">景区群发短信</div>
          <div class="flex_moeny">
            <div>
              <span class="fswh">当前余额：</span>
              <span class="fsw" v-model="recordData.qf_account">{{recordData.qf_account}}</span>
              <span class="fswh">元</span>
            </div>
            <div>
              <span class="fswh">充值金额：</span>
              <el-input placeholder="请输入内容" v-model="recordData.QfAmount" clearable>
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </div>
          </div>
        </div>
        <div class="connetThree">
          <div class="fsws">金飞鹰收款</div>
          <div>
            <div>
              <span class="fswh">到账金额：</span>
              <el-input placeholder="请输入内容" v-model="recordData.DzAmount" clearable>
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </div>
            <div>
              <span class="fswh">备注：</span>
              <el-input placeholder="备注内容" v-model="recordData.remarks" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="connetFour">
          <div class="fsws">短信单价管理</div>
          <div class="flex_moeny">
            <div>
              <span class="fswh">群发单价：</span>
              <el-input placeholder="请输入内容" v-model="recordData.MassPrice" clearable>
                <template>
                  <slot slot="suffix" class="input-slot">元/条</slot>
                </template>
              </el-input>
            </div>
            <div>
              <span class="fswh">订单短信：</span>
              <el-input placeholder="请输入内容" v-model="recordData.orderMsg" clearable>
                <template>
                  <slot slot="suffix" class="input-slot">元/条</slot>
                </template>
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 计时 -->
      <div class="conentBox" v-if="radioType==2">
        <div class="connetTimeOne">
          <div>景区订单短信——计时</div>
          <div>
            <div>
              <span>计费类型：</span>
              <el-radio-group v-model="recordData.radio" @change="radioFn">
                <el-radio :label="1">计费</el-radio>
                <el-radio :label="2">计时</el-radio>
              </el-radio-group>
            </div>
            <div>
              <div>
                <span class="fswh">当前余额：</span>
                <span class="fsw" v-model="recordData.timeMsgAmount">{{recordData.timeMsgAmount}}</span>
                <!-- <span class="fswh">元</span> -->
              </div>
              <div>
                <span class="fswh">延时充值:</span>
                <el-date-picker
                  v-model="recordData.delayRecharge"
                  type="daterange"
                  start-placeholder="选择日期"
                  end-placeholder="结束日期"
                  range-separator="至"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                <!-- <img :src="imgXlb" alt="" srcset=""> -->
                <!-- <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>-->
              </div>
            </div>
          </div>
        </div>
        <div class="connetTimeThree">
          <div class="fsws">金飞鹰收款</div>
          <div>
            <div>
              <span class="fswh">到账金额：</span>
              <el-input placeholder="请输入内容" v-model="recordData.timeAmount " clearable>
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </div>
            <div>
              <span class="fswh">备注：</span>
              <el-input placeholder="备注内容" v-model="recordData.timeRemarks" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="connetTimeFour">
          <div class="fsws">短信单价管理</div>
          <div>
            <div>
              <span class="fswh">计时短信:</span>
              <el-input placeholder="请输入内容" v-model="recordData.timeMsg" clearable>
                <template>
                  <slot slot="suffix" class="input-slot">元/天</slot>
                </template>
              </el-input>
            </div>
            <div>
              <span class="fswh">群发计时单价:</span>
              <el-input placeholder="请输入内容" v-model="recordData.MassPrice" clearable>
                <template>
                  <slot slot="suffix" class="input-slot">元/天</slot>
                </template>
              </el-input>
            </div>
            <!-- <div>
              <span class="fswh">订单短信：</span>
              <el-input placeholder="请输入内容" v-model="input" clearable>
                <template>
                  <slot slot="suffix" class="input-slot">元/条</slot>
                </template>
              </el-input>
            </div>-->
          </div>
        </div>
      </div>
      <div class="footer">
        <!-- <el-button class="canBtn">取消</el-button> -->
        <el-button class="sureBtn" @click="sureFn()">提交</el-button>
      </div>
    </el-dialog>
    <!-- 充值记录弹框结束 -->
  </div>
</template>

<script>
import { ScenicInfoPost, scenicPayPost } from "@/request/scenics.js";
import {Message } from 'element-ui'
export default { 
  data() {
    return {
      recordDialogVisible: false,
      // 充值记录传参----计费
      recordPar: {
        token: this.Token,
        scenic_id: "",
        charge_type: "",
        qf_price: "",
        commission: "",
        balance: "",
        qf_account: "",
        jfy_amount: "",
        remark: ""
      },
      // 充值记录传参----计时
      recordTimePar: {
        token: this.Token,
        scenic_id: "",
        charge_type: "",
        qf_price: "",
        commission: "",
        balance: "",
        qf_account: "",
        jfy_amount: "",
        remark: ""
      },
      // 计费绑定数据
      recordData: {
        radio: 1, // 计时计费单选
        balance: "", // 计费景区订单短信余额
        amount: "", // 计费群发短信余额
        qf_account: "", // 计费景区订单短信充值余额
        QfAmount: "", // 计费群发短信充值金额
        DzAmount: "", // 计费金飞鹰收款到账金额
        remarks: "", // 计费金飞鹰收款备注
        MassPrice: "", // 计费短信单价管理群发单价
        orderMsg: "", // 计费短信单价管理订单短信
        timeMsgAmount: "", // 计时景区订单短信余额
        delayRecharge: "", // 计时景区订单短信延时充值
        timeAmount: "", // 计时金飞鹰收款到账金额
        timeRemarks: "", // 计时金飞鹰收款备注
        timeMsg: "" // 计时短信单价管理计时短信
      },
      Token: "",
      scenicId: "",
      radioType: 1, // 计费计时切换
      upData: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.Token = sessionStorage.getItem("Token");
  },
  methods: {
    // 充值记录提交
    sureFn() {
      // 充值记录传参----计费
      this.recordPar = {
        token: this.Token,
        scenic_id: this.scenicId,
        charge_type: this.recordData.radio,
        qf_price: this.recordData.MassPrice,
        commission: this.recordData.orderMsg, // 订单/计时短信
        balance: this.recordData.amount,
        qf_account: this.recordData.QfAmount,
        jfy_amount: this.recordData.DzAmount,
        remark: this.recordData.remarks
      };
      let delayRecharge =
        this.recordData.delayRecharge[0] +" → " +
        this.recordData.delayRecharge[1];
        if(this.radioType==2){
          if(this.recordData.delayRecharge==''){
            delayRecharge = this.recordData.timeMsgAmount
          }
        }  
      // 充值记录传参----计时
      this.recordTimePar = {
        token: this.Token,
        scenic_id: this.scenicId,
        charge_type: this.recordData.radio,
        qf_price: this.recordData.MassPrice,
        commission: this.recordData.timeMsg, // 订单/计时短信
        balance: delayRecharge,
        qf_account: this.recordData.QfAmount,
        jfy_amount: this.recordData.timeAmount,
        remark: this.recordData.timeRemarks
      };
      if (this.recordData.radio == 2) {
        this.upData = this.recordTimePar;
      }
      if (this.recordData.radio == 1) {
        this.upData = this.recordPar;
      }
      scenicPayPost(this.upData).then(res => {
        console.log(res);
        if (res.data.rcode == 200) {
          Message.success(res.data.msg);
          let upData={
            token:this.Token
          }
          this.$parent.getList(upData);
          this.recordDialogVisible = false;
        } else {
          Message.error(res.data.msg);
        }
      });
    },
    // 计费计时
    radioFn(e) {
      console.log(e);
      this.radioType = e;
    },
    // 充值记录
    record(row) {
      // console.log(row);
      // this.recordData.radio = row.charge; //计费类型赋值
      this.recordDialogVisible = true;
      this.scenicId = row.ScenicID;
      let upData = {
        scenic_id: row.ScenicID,
        token: this.Token
      };
      ScenicInfoPost(upData).then(res => {
        this.radioType = res.data.result.charge; //切换计时还是计费
        if (res.data.result.charge == 1) {
          console.log("hasgsakg",res);
          this.recordData = {
            radio: res.data.result.charge, // 计时计费单选
            balance: res.data.result.Balance, // 计费景区订单短信余额
            amount: "", // 计费群发短信余额
            qf_account: res.data.result.qf_account, // 计费景区订单短信充值余额
            QfAmount: "", // 计费群发短信充值金额
            DzAmount: "", // 计费金飞鹰收款到账金额
            remarks: "", // 计费金飞鹰收款备注
            MassPrice: res.data.result.qf_price, // 计费短信单价管理群发单价
            orderMsg: res.data.result.Commission, // 计费短信单价管理订单短信
            timeMsgAmount: res.data.result.charge_time, // 计时景区订单短信余额
            delayRecharge: "", // 计时景区订单短信延时充值
            timeAmount: "", // 计时金飞鹰收款到账金额
            timeRemarks: "", // 计时金飞鹰收款备注
            timeMsg:res.data.result.sms_day_price // 计时短信单价管理计时短信
          };
        }
        if (res.data.result.charge == 2) {
          this.recordData = {
            radio: res.data.result.charge, // 计时计费单选
            balance:res.data.result.Balance, // 计费景区订单短信余额
            amount: "", // 计费群发短信余额
            qf_account: "", // 计费景区订单短信充值余额
            QfAmount: "", // 计费群发短信充值金额
            DzAmount: "", // 计费金飞鹰收款到账金额
            remarks: "", // 计费金飞鹰收款备注
            MassPrice: res.data.result.qf_price, // 计费短信单价管理群发单价
            orderMsg: res.data.result.Commission, // 计费短信单价管理订单短信
            timeMsgAmount: res.data.result.charge_time, // 计时景区订单短信余额
            delayRecharge: "", // 计时景区订单短信延时充值
            timeAmount: "", // 计时金飞鹰收款到账金额
            timeRemarks: "", // 计时金飞鹰收款备注
            timeMsg: res.data.result.sms_day_price // 计时短信单价管理计时短信
          };
          // this.recordData.timeMsgAmount = row.charge_time;
        }
      });
    },
    // 充值记录X
    recordHandleClose() {
      this.recordDialogVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.conentBox {
  .connetOne {
    // padding: 20px;
    // border: 1px solid yellow;
    > div:nth-child(1) {
      width: 84px;
      height: 20px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
    > div:nth-child(2) {
       //  height: 81px;
      margin-top: 7px;
      background: #ffffff;
      border: 1px solid #e5e5ea;
      border-radius: 4px;
      padding: 20px ;
      box-sizing: border-box;
      > div:nth-child(1) {
        width: 200px;
        height: 20px;
        display: flex;
        span {
          width: 100px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #666666;
        }
        .el-radio-group {
          width: 80px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          .el-radio {
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            /* identical to box height */
            color: #000000;
          }
        }
      }
      > div:nth-child(2) {
        width: 100%;
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        > div:nth-child(1) {
          > span:nth-child(1) {
            width: 100px;
            height: 20px;
          }
          > span:nth-child(2) {
            display: inline-block;
            width: 80px;
            height: 20px;
            text-align: center;
            margin-right: 10px;
          }
        }
        > div:nth-child(2) {
          display: flex;
          align-items: center;
          /deep/.el-input__inner {
            // width: 280px;
            height: 40px;
          }
          span {
            width: 110px;
            height: 20px;
          }
        }
      }
    }
  }
}
.connetTwo {
  margin: 17px 0;
  > div:nth-child(1) {
    margin-bottom: 7px;
  }
  > div:nth-child(2) {
    // width: 100%;
    // height: 21px;
    padding: 31px 20px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;
    align-items: center;
    > div:nth-child(1) {
      > span:nth-child(2) {
        display: inline-block;
        width: 80px;
        height: 20px;
        text-align: center;
        margin-right: 10px;
      }
    }
    > div:nth-child(2) {
      display: flex;
      span {
        width: 110px;
        height: 40px;
        line-height: 40px;
      }
      /deep/.el-input__inner {
        // width: 280px;
        height: 40px;
      }
    }
  }
}
.connetThree {
  margin-bottom: 17px;
  > div:nth-child(1) {
    margin-bottom: 7px;
  }
  > div:nth-child(2) {
     //  height: 81px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 31px 20px;
    > div:nth-child(1) {
      // height: 50px;
      display: flex;
      span {
        display: inline-block;
        // width: 12%;
        height: 40px;
        line-height: 40px;
      }
      /deep/.el-input {
        width: 70%;
        margin-bottom: 20px;
      }
      /deep/.el-input__inner {
        width: 100%;
        height: 40px;
      }
    }
    > div:nth-child(2) {
      display: flex;
      span {
        display: inline-block;
        // width: 12%;
        height: 40px;
        line-height: 40px;
        padding-left: 25px;
        box-sizing: border-box;
      }
      /deep/.el-input {
        width:70%;
        margin-bottom: 20px;
      }
      /deep/.el-input__inner {
        width: 100%;
        height: 40px;
      }
    }
  }
}
.connetFour {
  margin-bottom: 17px;
  > div:nth-child(1) {
    margin-bottom: 7px;
  }
  > div:nth-child(2) {
    // height: 40px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 31px 20px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    > div:nth-child(1) {
      height: 40px;
      margin-bottom: 1rem;
      display: flex;
      span {
        display: inline-block;
        width: 30%;
        // height: 40px;
        line-height: 40px;
      }
      /deep/.el-input {
        width: 70%;
        margin-bottom: 20px;
      }
      /deep/.el-input__inner {
        width: 92%;
        // height: 40px;
      }
    }
    > div:nth-child(2) {
      margin-bottom: 1rem;
      height: 40px;
      display: flex;
      span {
        display: inline-block;
        width: 30%;
        height: 40px;
        line-height: 40px;
      }
      /deep/.el-input {
        width: 70%;
        margin-bottom: 20px;
        position: relative;
      }
      /deep/.el-input__inner {
        width: 92%;
        height: 40px;
      }
    }
  }
}

.connetTimeOne {
  // padding: 20px;
  // border: 1px solid yellow;
  > div:nth-child(1) {
    width: 84px;
    height: 20px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height */
    color: #666666;
  }
  > div:nth-child(2) {
    // height: 81px;
    margin-top: 7px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px ;
    box-sizing: border-box;
    > div:nth-child(1) {
      width: 200px;
      height: 20px;
      display: flex;
      span {
        width: 100px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
      .el-radio-group {
        width: 80px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        .el-radio {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */
          color: #000000;
        }
      }
    }
    > div:nth-child(2) {
      width: 100%;
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      > div:nth-child(1) {
        > span:nth-child(1) {
          width: 100px;
          height: 20px;
        }
        > span:nth-child(2) {
          display: inline-block;
          // width: 167px;
          height: 20px;
          // text-align: center;
          // margin-right: 10px;
          margin-left: 12px;
        }
      }
      > div:nth-child(2) {
        margin-top: 1rem;
        display: flex;
        align-items: center;
        /deep/.el-date-editor {
          width: auto;
          height: 40px;
        }
        span {
          width: 110px;
          height: 20px;
        }
      }
    }
  }
}

.connetTimeThree {
  margin-bottom: 17px;
  > div:nth-child(1) {
    margin-bottom: 7px;
  }
  > div:nth-child(2) {
    // height: 81px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 31px 20px;
    > div:nth-child(1) {
      // height: 50px;
      display: flex;
      flex-wrap: wrap;
      span {
        display: inline-block;
        // width: 12%;
        height: 40px;
        line-height: 40px;
      }
      /deep/.el-input {
        width: 70%;
        margin-bottom: 20px;
      }
      /deep/.el-input__inner {
        width: 100%;
        height: 40px;
      }
    }
    > div:nth-child(2) {
      flex-wrap: wrap;
      display: flex;
      span {
        display: inline-block;
        // width: 12%;
        height: 40px;
        line-height: 40px;
        padding-left: 25px;
        box-sizing: border-box;
      }
      /deep/.el-input {
        width: 70%;
        margin-bottom: 20px;
      }
      /deep/.el-input__inner {
        width: 100%;
        height: 40px;
      }
    }
  }
}

.connetTimeFour {
  margin-bottom: 17px;
  .fswh{
    width: 35% !important;
  }
  > div:nth-child(1) {
    margin-bottom: 7px;
  }
  > div:nth-child(2) {
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 31px 20px;
    display: flex;
    > div:nth-child(1) {
      display: flex;
      span {
        display: inline-block;
        width: 30%;
        // height: 40px;
        line-height: 40px;
      }
      /deep/.el-input {
        width: 90%;
        margin-bottom: 20px;
      }
      /deep/.el-input__inner {
        width: 92%;
        // height: 40px;
      }
    }
    > div:nth-child(2) {
      width: 50%;
      height: 40px;
      display: flex;
      span {
        display: inline-block;
        width: 30%;
        height: 40px;
        line-height: 40px;
      }
      /deep/.el-input {
        width: 90%;
        margin-bottom: 20px;
        position: relative;
      }
      /deep/.el-input__inner {
        width: 92%;
        height: 40px;
      }
    }
  }
}

/deep/.el-input__suffix {
  right: 30px;
  transition: all 0.3s;
  pointer-events: none;
  height: 40px;
  line-height: 40px;
}

// 取消确认按钮
.footer {
  width: 100%;
  text-align: center;
  margin-top: 42px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
  .sureBtn {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-dialog{
  min-width: 400px;
}
.flex_moeny{
  display: flex;
  justify-content: space-between;
}
/deep/ .el-dialog__title{
  color: #000 !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}

</style>